import { PendingTerms } from "../models/terms/pendingTerms";
import { TermsWebService } from "../webservices/terms.web.service";
import { userManagementService } from "./user-management.service";

// Terms flow is coordinated centrally (see utils/termsAcknowledgement.ts).
// This service calls the web service directly, without retryWithAuth, so the
// terms endpoints can never re-enter the terms-acknowledgement handling.
export class TermsService {

  private static instance: TermsService;

  private constructor() {}

  public static getInstance(): TermsService {
    if (!TermsService.instance) {
      TermsService.instance = new TermsService();
    }
    return TermsService.instance;
  }

  public async getPendingTerms(): Promise<PendingTerms | undefined> {
    const organizationId = this.getOrganizationId();
    const webService = new TermsWebService();
    return webService.getPendingTerms(organizationId);
  }

  public async acknowledgeTerms(): Promise<void> {
    const organizationId = this.getOrganizationId();
    const webService = new TermsWebService();
    return webService.acknowledgeTerms(organizationId);
  }

  private getOrganizationId(): string {
    const organisatie = userManagementService.getStoredOrganisatie();
    if (!organisatie?.id) {
      throw new Error("Geen actieve organisatie gevonden.");
    }
    return organisatie.id;
  }
}

export const termsService = TermsService.getInstance();
